import 'tinymce/tinymce';
import 'tinymce/icons/default';
import 'tinymce/themes/silver';
import 'tinymce/models/dom';
import 'tinymce/plugins/link';
import 'tinymce/plugins/lists';
import 'tinymce/skins/ui/tinymce-5/skin.min.css';
import { Editor } from '@tinymce/tinymce-react';

type Props = {
  value: string;
  onChange: (changes: string) => void;
  width?: number;
  height?: number;
};

export const LegacyRichTextarea = (props: Props) => {
  const { width, height, value, onChange } = props;

  return (
    <Editor
      value={value}
      onEditorChange={onChange}
      init={{
        width: width || 700,
        height: height || 300,
        resize: false,
        menubar: false,
        plugins: ['lists', 'link'].join(' '),
        toolbar: [
          'bold italic',
          'numlist bullist indent outdent',
          'link unlink',
          'styles',
          'removeformat',
          'cut copy pastetext',
        ].join('|'),
        content_style: `body {
          font-family: sans-serif, Arial, Verdana, "Trebuchet MS", "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
          line-height: 1.6;
          font-size: 13px;
        }`,
      }}
    />
  );
};
